var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page-full"},[_c('back-nav'),_c('div',{staticClass:"img-div"},[_c('van-image',{attrs:{"round":"","width":"375","src":require('@/assets/images/500.png')}}),_c('p',{staticClass:"error-tips"},[_vm._v("服务器忙，请稍后再试吧～")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }